import { useState } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import classnames from "classnames"
import Logo from "components/logo"
import { useSaveContextPreferences } from "hooks/preferences"
import { LINK } from "../../shapes"
import SubLink from "./sublink"
import "./style.scss"

function MobileNav({ portfolioName, home, links }) {
  const [open, setOpen] = useState(false)

  const saveLastLocationPreference = useSaveContextPreferences("navigation.root")

  const toggle = () => {
    setOpen(prevOpen => !prevOpen)
  }

  return <div className={classnames("toggle", { open })} onClick={toggle}>
    <i className="fa fa-bars" />
    <div className={classnames("menu", { open })}>
      <div className="portfolio-name group">
        {portfolioName}
      </div>
      <Link to={home} className="mobile-link group">
        <Logo className="icon" />
        <div className="label">Home</div>
      </Link>
      {links.map(link =>
        <div key={link.id} className="group">
          <Link onClick={() => saveLastLocationPreference(link.id)} to={link.to} className="mobile-link">
            <i className={`icon fa fa-${link.icon}`} />
            <div className="label">{link.label}</div>
          </Link>
          {link.subItems
            .filter(subLink => !subLink.hidden)
            .map(subLink =>
              <SubLink id={subLink.id} parentId={link.id} key={subLink.id} to={subLink.to} label={subLink.label} />,
            )}
        </div>,
      )}
      <div className="footer">
        <Logo className="logo" />
        <div className="brand">Omega Point</div>
        <div className="product">Portfolio Intelligence</div>
      </div>
    </div>
  </div>
}

MobileNav.propTypes = {
  links: PropTypes.arrayOf(LINK).isRequired,
  portfolioName: PropTypes.string.isRequired,
  home: PropTypes.string.isRequired,
}

export default MobileNav
